import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { ErrorToast, SuccessToast } from 'services/toasterService';

export default function useDeletePerformance() {
  const queryClient = useQueryClient();

  return useMutation(
    async (data) => {
      const response = await makeApiRequest.delete(apiEndPoints.PERFORMANCE_BY_ADMIN, {
        data: data,
      });
      return response?.data;
    },
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries('delete_performance');
        SuccessToast({ text: data?.message });
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
